import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import priceList from "@/data/services/online-marketing/price-list.json";
import infoData from "@/data/services/online-marketing/smm/smm.json";
import faq from "@/data/services/online-marketing/smm/faq.json";
import PageSEO from "@/components/common/PageSEO";
import Intro from "@/components/service/components/intro/Intro";
import PriceList from "@/components/service/components/price-list/PriceList";
import VisualBenefits from "@/components/service/components/visual-benefits/VisualBenefits";
import Faq from "@/components/contact/faq/Faq";
import Socials from "@/components/service/online-marketing/smm/smm-socials/Socials";
import Spacing from "@/components/common/Spacing";

const Smm = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <>
      <PageSEO section="services" keyName="smm" />
      <Intro data={infoData} branding={true} />
      <VisualBenefits 
        icon="number" 
        data={infoData} 
        onClick={() => navigate("/portfoliu/smm-content")}
      />
      <Container style={{ height: "100%" }}>
      </Container>
      <Socials />
      <Container>
        <Spacing size={4} />
        <PriceList data={priceList} />
        <Faq data={faq} />
      </Container>
    </>
  );
};

export default Smm;